import { URL_TABLEAU_DE_BORD } from '../shared/constants/url.constants';

/**
 * Contient les variables d'environnement utiles à la librairie.
 * À renseigner par l'application utilisant la librairie au moment du chargement de l'application.
 */
export class Environment {
    static host: string = null;
    static apiUrl: string = null;
    static managementUrl: string = null;
    static defaultLandingPage: string = URL_TABLEAU_DE_BORD;

    static webSocketBluetoothPrinting: string = 'ws://localhost:8098';
    static showGenerateSimpleIntervention: boolean = true;
    static defaultBucket: string = 'wizydiag-api';
    static apiDwgUrl: string = '/api/dwg-to-dxf';

    static appName: string = 'CN-DIAG';
    static appVersion: string = null;

    /* Paramétrage de la gestion des utilisateurs */

    /** Possibilité de simplement archiver l'utilisateur (en plus de la suppression classique) */
    static canArchiveUser: boolean = false;

    /** Possibilité de remplacer l'utilisateur par un autre */
    static canReplaceUser: boolean = false;

    /** Possibilité de modifier le mot de passe d'un utilisateur */
    static canSetUserPassword: boolean = false;
    static apiWikipimUrl: string;
    static apiCnbimUrl: string;

    static production: boolean = false;
    static development: boolean = true;
    static serviceWorker: boolean = false;
    static adAuthentication: boolean = false;

    static cacherAgendaDashboard: boolean = true;
    static cacherLotsInterventionsDashboard: boolean = true;
    static cacherToDoListDashboard: boolean = true;
    static cacherMissionsEnCoursDashboard: boolean = true;
    static cacherGestionInterventionsDashboard: boolean = false;
    static cacherGestionReferentielsDashboard: boolean = false;
    static cacherGestionBiensDashboard: boolean = false;
    static cacherGestionContactsDashboard: boolean = false;
    static cacherGestionCommandesDashboard: boolean = false;
    static cacherGestionSynthesesDashboard: boolean = false;
    static cacherGestionEmployesDashboard: boolean = false;
    static cacherGestionAgencesDashboard: boolean = false;
    static cacherGestionCofracsDashboard: boolean = false;
    static cacherGestionBonsCommande: boolean = false;
    static cacherGestionDocuments: boolean = false;
    static cacherCommentairesPredefinis: boolean = false;
    static cacherGestionLivrablesDashboard: boolean = false;
    static interventionMinusDay: number = 0;
    static interventionPlusDay: number = 1;
}
